// Initialize a global array to store the product handles
var currentProductHandles = [];

if (!customElements.get("product-form")) {
  customElements.define(
    "product-form",
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector("form");

        if (this.form) {
          this.variantIdInput.disabled = false;
          this.form.addEventListener("submit", this.onSubmitHandler.bind(this));
          this.cart =
            document.querySelector("cart-notification") ||
            document.querySelector("cart-drawer");
          this.submitButton = this.querySelector('[type="submit"]');
          this.submitButtonText = this.submitButton.querySelector("span");

          if (document.querySelector("cart-drawer"))
            this.submitButton.setAttribute("aria-haspopup", "dialog");

          this.hideErrors = this.dataset.hideErrors === "true";
        }
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();

        // ── Disable button IMMEDIATELY on click — before any async work.
        //    Prevents double-clicks submitting multiple cart requests.
        if (this.submitButton.getAttribute("aria-disabled") === "true") return;
        this.submitButton.setAttribute("aria-disabled", true);
        this.querySelector(".loading__spinner")?.classList.remove("hidden");

        // ── Cross-sell popup flow ─────────────────────────────────────────
        //    Runs before cart fetch. If popup opens, re-enable the button
        //    immediately so the user can interact again after dismissing.
        if (!window.location.pathname.includes("/cart")) {
          await crossSellPopup(this.submitButton);

          // Re-enable button and hide spinner after popup has opened.
          // The cart fetch still runs in background below.
          // If no popup (no cross-sells), button stays disabled until
          // fetch completes in finally block.
          if (document.body.classList.contains("cross-sell-open")) {
            this.submitButton.removeAttribute("aria-disabled");
            this.querySelector(".loading__spinner")?.classList.add("hidden");
          }
        }

        this.handleErrorMessage();

        const config = fetchConfig("javascript");
        config.headers["X-Requested-With"] = "XMLHttpRequest";
        delete config.headers["Content-Type"];
        const formData = new FormData(this.form);

        // ── Bulk buy quantity logic ───────────────────────────────────────
        let quantityQuickView;
        const selectedBulkBuy = document.querySelector(
          '.main-bulk-buy input[name="bulk_buy_qty"]:checked'
        );

        if (selectedBulkBuy) {
          quantityQuickView = selectedBulkBuy.closest("label").dataset.qty;
        }

        let currentQuantity = null;
        const isMainBuyButton =
          this.submitButton.classList.contains("main_buy_button");
        const quantityInput = document.querySelector(
          ".price_quantity_wrapper .quantity__input"
        );
        const bulk_buy_utm_parameter = this.submitButton.classList.contains(
          "bulk_buy_utm_parameter"
        );
        const isInsideMainAddToBasket =
          this.submitButton.closest(".main-add-to-basket") !== null;
        const xvdStored = sessionStorage.getItem("xvd_found");

        let quantity = 1; // default fallback

        if (isMainBuyButton) {
          if (bulk_buy_utm_parameter) {
            if (xvdStored === "true") {
              quantity = quantityInput?.value || quantityQuickView || 1;
            } else {
              if (isInsideMainAddToBasket) {
                quantity = quantityInput?.value || quantityQuickView || 1;
              } else {
                quantity = quantityQuickView || 1;
              }
            }
          } else {
            quantity = quantityInput?.value || quantityQuickView || 1;
          }

          currentQuantity = quantity;
          const productForm = this.submitButton.closest("product-form");

          if (productForm) {
            const hiddenInput = productForm.querySelector(
              ".updated-product-quantity"
            );
            if (hiddenInput) {
              hiddenInput.value = quantity;
              formData.set("quantity", hiddenInput.value);
            }
          }
        }

        // ── Cart sections ─────────────────────────────────────────────────
        if (this.cart) {
          formData.append(
            "sections",
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append("sections_url", window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: "product-form",
                productVariantId: formData.get("id"),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage =
                this.submitButton.querySelector(".sold-out-message");
              if (!soldOutMessage) return;
              this.submitButton.setAttribute("aria-disabled", true);
              soldOutMessage.classList.remove("hidden");
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker(
              "add:wait-for-subscribers"
            );

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: "product-form",
                productVariantId: formData.get("id"),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker(
                  "add:wait-for-subscribers",
                  startMarker
                );
              });

            this.error = false;
            const quickAddModal = this.closest("quick-add-modal");

            if (quickAddModal) {
              document.body.addEventListener(
                "modalClosed",
                () => {
                  setTimeout(() => {
                    CartPerformance.measure(
                      "add:paint-updated-sections",
                      () => {
                        // Quick add modal — open drawer normally
                        this.cart.renderContents(response);
                      }
                    );
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              if (!window.location.pathname.includes("/cart")) {
                CartPerformance.measure("add:paint-updated-sections", () => {
                  // skipOpen: true — update cart count bubble and drawer
                  // HTML silently without opening the drawer.
                  // Cross-sell popup handles the UX instead.
                  if (this.cart.renderContents) {
                    this.cart.renderContents(response, { skipOpen: true });
                  }
                });
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove("loading");

            if (this.cart && this.cart.classList.contains("is-empty"))
              this.cart.classList.remove("is-empty");

            // Re-enable button after fetch completes.
            // If cross-sell popup is open, button was already re-enabled
            // above — this is a no-op in that case (removeAttribute is safe
            // to call when attribute doesn't exist).
            if (!this.error) {
              this.submitButton.removeAttribute("aria-disabled");
            }

            this.querySelector(".loading__spinner")?.classList.add("hidden");

            if (window.location.pathname.includes("/cart")) {
              setTimeout(() => {
                window.initializeCarousel();
              }, 1200);
            }

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper ||
          this.querySelector(".product-form__error-message-wrapper");
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage ||
          this.errorMessageWrapper.querySelector(
            ".product-form__error-message"
          );

        this.errorMessageWrapper.toggleAttribute("hidden", !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute("disabled", "disabled");
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute("disabled");
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector("[name=id]");
      }
    }
  );
}

async function crossSellPopup(submitButton) {
  const clickedProductTitle = submitButton.getAttribute("data-title");
  const clickedProductDescription =
    submitButton.getAttribute("data-description");
  const clickedProductImage = submitButton.getAttribute("data-product-image");
  const metaFieldProductHandles = submitButton.getAttribute("data-handles");

  const popup = document.querySelector(".main-popup-card");
  const body = document.body;
  const upsellProductList = document.getElementById("upsell-product-list");

  const productPopupTitle = document.querySelector(".product-popup-title");
  const productSubheadingDescription = document.querySelector(
    ".product-subheading-description"
  );
  const productfeaturedImage = document.querySelector(
    ".cross-sell-product-featured"
  );

  const closePopup = () => {
    if (popup) popup.classList.add("hidden");
    body.classList.remove("cross-sell-open");
  };

  const openPopup = () => {
    if (popup) popup.classList.remove("hidden");
    body.classList.add("cross-sell-open");
  };

  if (!metaFieldProductHandles) {
    closePopup();
    return;
  }

  const productHandles = metaFieldProductHandles
    .split(",")
    .map((h) => h.trim())
    .filter(Boolean);

  let cartHandles = new Set();

  try {
    const cartResponse = await fetch("/cart.js");
    const cart = await cartResponse.json();
    cartHandles = new Set(cart.items.map((item) => item.handle));
  } catch (error) {
    console.error("Cart fetch error:", error);
  }

  const filteredHandles = productHandles.filter(
    (handle) => !cartHandles.has(handle)
  );

  currentProductHandles = filteredHandles;

  if (!filteredHandles.length) {
    closePopup();
    return;
  }

  if (productPopupTitle)
    productPopupTitle.textContent = clickedProductTitle || "";
  if (productSubheadingDescription)
    productSubheadingDescription.textContent = clickedProductDescription || "";
  if (productfeaturedImage)
    productfeaturedImage.src = clickedProductImage || "";

  // Tear down the previous owl instance BEFORE re-rendering. innerHTML = "" only
  // clears children — it leaves the .owl-loaded class on the list, which blocks the
  // pre-init CSS so the new cards stack ("shows 1 then 3"). Destroying first removes
  // that class, so the cards lay out 3-across immediately, then owl re-inits in place.
  if (window.jQuery && $(".cross-cell-products-owl-carousel").data("owl.carousel")) {
    $(".cross-cell-products-owl-carousel").trigger("destroy.owl.carousel");
  }

  upsellProductList.innerHTML = "";

  const fragment = document.createDocumentFragment();

  const productPromises = filteredHandles.map(async (handle) => {
    const url = `/products/${handle}?view=card`;

    try {
      const res = await fetch(url);
      const html = await res.text();

      const li = document.createElement("li");
      li.className = "owl-slide slider-item";
      li.innerHTML = html;

      fragment.appendChild(li);
    } catch (err) {
      console.error("Product fetch error:", err);
    }
  });

  await Promise.all(productPromises);

  upsellProductList.appendChild(fragment);

  initializeCrossSellCarousel();

  openPopup();
}

// ── Cross-sell popup close handlers ──────────────────────────────────────────
var crossPopupCloseButton = document.querySelector("#close-popup");
var continueShopping = document.querySelector(".continue-shopping_button");
var crossSellModal = document.querySelector(".main-popup-card");

function closeModal() {
  crossSellModal?.classList.add("hidden");
  document
    .querySelector("body")
    .classList.remove("cross-sell-open", "overflow-hidden");
}

crossPopupCloseButton?.addEventListener("click", function () {
  closeModal();
});

continueShopping?.addEventListener("click", function () {
  closeModal();
});

document.addEventListener("click", (event) => {
  if (event.target.classList.contains("cross-cell-outer-container")) {
    closeModal();
  }
});

function initializeCrossSellCarousel() {
  setTimeout(() => {
  if ($(".cross-cell-products-owl-carousel").data("owl.carousel")) {
    $(".cross-cell-products-owl-carousel").trigger("destroy.owl.carousel");
  }

  $(".cross-cell-products-owl-carousel").owlCarousel({
    loop: true,
    nav: true,
    margin: 10,
    responsive: {
      0: {
        items: 1.5,
        dots: false,
        margin: 20,
      },
      600: {
        items: 2,
        dots: false,
        margin: 20,
      },
      768: {
        items: 2,
        dots: false,
        margin: 20,
      },
      990: {
        items: 3,
        dots: false,
        margin: 20,
      },
    },
  });
  }, 1000);
}